{
  "version": 1,
  "asset_id": "f520c901-aae1-4305-a2ad-ad8b6231b6d5",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/f520c901-aae1-4305-a2ad-ad8b6231b6d5/lt11.jpg",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/f520c901-aae1-4305-a2ad-ad8b6231b6d5/lt11.jpg",
  "original_filename": "lt11.jpg",
  "size": 98636,
  "content_type": "image/jpeg",
  "created_at": "2026-06-15T15:38:39Z"
}
